/* Product-card slideshow, swipe, automatic rotation, and image zoom. */
(() => {
  let zoomDialog;
  const getZoomDialog = () => {
    if (zoomDialog) return zoomDialog;
    zoomDialog = document.createElement('dialog');
    zoomDialog.className = 'product-card-zoom';
    zoomDialog.setAttribute('aria-label', 'Product image zoom');
    zoomDialog.innerHTML = '<button class="product-card-zoom__close" type="button" aria-label="Close image zoom">&times;</button><img src="" alt="">';
    document.body.appendChild(zoomDialog);
    zoomDialog.querySelector('.product-card-zoom__close').addEventListener('click', () => zoomDialog.close());
    zoomDialog.addEventListener('click', (event) => { if (event.target === zoomDialog) zoomDialog.close(); });
    return zoomDialog;
  };

  document.querySelectorAll('[data-product-card-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-product-card-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-product-card-slide]'));
    const current = gallery.querySelector('[data-product-card-current]');
    if (!track || !slides.length) return;
    let index = 0;
    let startX = null;
    let startY = null;
    let swiped = false;
    let swipeHandled = false;
    let timer;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${index * 100}%,0,0)`;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });
      if (current) current.textContent = String(index + 1);
    };

    const stopAuto = () => { if (timer) window.clearInterval(timer); timer = undefined; };
    const startAuto = () => {
      stopAuto();
      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => show(index + 1), 3500);
    };
    const openZoom = () => {
      const slide = slides[index];
      const dialog = getZoomDialog();
      const image = dialog.querySelector('img');
      image.src = slide.dataset.zoomSrc || slide.querySelector('img')?.currentSrc || '';
      image.alt = slide.dataset.zoomAlt || slide.querySelector('img')?.alt || '';
      dialog.showModal();
    };

    gallery.querySelector('[data-product-card-previous]')?.addEventListener('click', () => { show(index - 1); startAuto(); });
    gallery.querySelector('[data-product-card-next]')?.addEventListener('click', () => { show(index + 1); startAuto(); });
    gallery.querySelector('[data-product-card-zoom]')?.addEventListener('click', openZoom);
    slides.forEach((slide) => slide.addEventListener('click', (event) => {
      if (swiped) { event.preventDefault(); swiped = false; return; }
      openZoom();
    }));
    gallery.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      startY = event.clientY;
      swiped = false;
      swipeHandled = false;
      stopAuto();
      gallery.setPointerCapture?.(event.pointerId);
    });
    gallery.addEventListener('pointermove', (event) => {
      if (swipeHandled || startX === null || startY === null) return;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) >= 24 && Math.abs(deltaX) > Math.abs(deltaY)) {
        swiped = true;
        swipeHandled = true;
        show(index + (deltaX < 0 ? 1 : -1));
        startX = null;
        startY = null;
      }
    });
    gallery.addEventListener('pointerup', (event) => {
      if (startX === null) {
        startAuto();
        return;
      }
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) >= 24 && Math.abs(deltaX) > Math.abs(deltaY)) {
        swiped = true;
        show(index + (deltaX < 0 ? 1 : -1));
      }
      startX = null;
      startY = null;
      startAuto();
    });
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    gallery.addEventListener('mouseenter', stopAuto);
    gallery.addEventListener('mouseleave', startAuto);
    gallery.addEventListener('focusin', stopAuto);
    gallery.addEventListener('focusout', startAuto);
    show(0);
    startAuto();
  });
})();